import { render, staticRenderFns } from "./CaixaResumo.vue?vue&type=template&id=10865572&scoped=true"
import script from "./CaixaResumo.vue?vue&type=script&lang=js"
export * from "./CaixaResumo.vue?vue&type=script&lang=js"
import style0 from "./CaixaResumo.vue?vue&type=style&index=0&id=10865572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10865572",
  null
  
)

export default component.exports